import { render, staticRenderFns } from "./modalMarginApprovalAll.vue?vue&type=template&id=6d4fcb22&scoped=true"
import script from "./modalMarginApprovalAll.vue?vue&type=script&lang=js"
export * from "./modalMarginApprovalAll.vue?vue&type=script&lang=js"
import style0 from "./modalMarginApprovalAll.vue?vue&type=style&index=0&id=6d4fcb22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4fcb22",
  null
  
)

export default component.exports